import { gql, useMutation } from '@apollo/client';
import { ONBOARDING_EVENT_STEP as ONBOARDING_STEPS } from '~../__queries__/globalTypes';
import { useSelector } from '~Hooks';

export const ONBOARDING_EVENT_STEP = ONBOARDING_STEPS;

const ADD_ONBOARDING_EVENT = gql`
  mutation AddOnboardingEvent($data: OnboardingEventInput!) {
    addOnboardingEvent(input: $data) {
      success
      error
      message
    }
  }
`;

/* 
This hook is purely for tracking onboarding events for new customers.
To view the events, view the page in Venue Manager.

Usage: const onbTracker = useOnboardingTracker();
onbTracker.event(ONBOARDING_EVENT_STEP.SIGNUP);
*/

export const useOnboardingTracker = () => {
  const [addOnboardingEvent] = useMutation(ADD_ONBOARDING_EVENT);
  const companyId = useSelector((state) => state.company);

  const event = async (name: ONBOARDING_STEPS) => {
    const inputData = {
      name,
      companyId,
    };

    await addOnboardingEvent({ variables: { data: inputData } });
  };

  return { event };
};
